import { Input } from "./styled";

export const InputCustom = ({ width, className, error, ...other }) => {
  return (
    <Input
      error={error}
      className={`h-[50px] lg:h-[58px] ${className}`}
      width={width}
      {...other}
    />
  );
};
